import { useEffect, useState } from 'react';
import { Modal } from '@/components/ui/Modal/Modal';
import { Input } from '@/components/ui/Input/Input';
import { Button } from '@/components/ui/Button/Button';
import './ReaderTagGroupRenameModal.css';

export interface ReaderTagGroupRenameModalProps {
  open: boolean;
  groupName: string;
  onClose: () => void;
  onRename: (newName: string) => Promise<void>;
  saving: boolean;
}

export function ReaderTagGroupRenameModal({
  open,
  groupName,
  onClose,
  onRename,
  saving,
}: ReaderTagGroupRenameModalProps) {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (open) setValue(groupName);
  }, [open, groupName]);

  const handleClose = () => {
    if (!saving) {
      setValue('');
      onClose();
    }
  };

  const submit = async () => {
    const n = value.trim();
    if (!n) return;
    try {
      await onRename(n);
    } catch {
      /* ошибка показывается в onError мутации */
    }
  };

  return (
    <Modal open={open} onClose={handleClose} title="Переименовать группу" headerVariant="island" size="sm">
      <div className="reader-tag-group-rename-modal">
        <Input
          placeholder="Новое название группы"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={saving}
          maxLength={128}
          fullWidth
          autoComplete="off"
          aria-label="Новое название группы"
        />
        <div className="form__footer form__footer_modal reader-tag-group-rename-modal__footer">
          <Button type="button" variant="outlined" size="m" fullWidth onClick={handleClose} disabled={saving}>
            Отмена
          </Button>
          <Button
            type="button"
            size="m"
            fullWidth
            onClick={() => void submit()}
            disabled={saving || !value.trim() || value.trim() === groupName}
          >
            {saving ? 'Сохранение…' : 'Сохранить'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
